"use client";

import { useEffect } from "react";
import { reportErrorToRum } from "@/lib/rum";

// Root-layout error boundary. Catches errors that occur inside the root
// layout itself (providers, fonts, etc). Replaces the whole document, so it
// must provide its own <html> and <body>. CSS may not be loaded at this
// point — inline styles are safer than Tailwind here.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportErrorToRum(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          fontFamily: "system-ui, -apple-system, sans-serif",
          margin: 0,
          padding: "2rem",
          background: "#fff",
          color: "#111",
        }}
      >
        <div
          style={{
            maxWidth: "600px",
            margin: "4rem auto",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>
            Something went wrong
          </h1>
          <p style={{ marginBottom: "1.5rem", color: "#666" }}>
            We&apos;ve been notified and are looking into it.
          </p>
          <button
            onClick={reset}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "0.375rem",
              border: "1px solid #ccc",
              background: "#fff",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
